/**
 * NACHA CSV Processor Application Entry Point
 * 
 * This file serves as the entry point for the application, rendering the main App component
 * into the DOM and setting up React's StrictMode for development error checking.
 * 
 * The application converts CSV files to NACHA formatted files for ACH bank transfers,
 * with specific focus on Chase Bank requirements.
 * 
 * @author Richard McGirr
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
